import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrogeneticsComponent } from './simple-icons-microgenetics.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrogeneticsComponent ],
    exports:      [ SimpleIconsMicrogeneticsComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrogeneticsModule {}
